import { useEffect } from 'react';
import BasicModal from './BasicModal';
import { Mixpanel } from '../../services/Mixpanel';
import { useError } from '../../contexts/ErrorContext';
import { formatQuotaResetsAt, resourceNoun } from '../../utils/isProjectQuotaExceeded';
import { openQuotaUpgrade } from '../../utils/openQuotaUpgrade';

export default function ProjectQuotaModal() {
  const { projectQuotaState, hideProjectQuotaError } = useError();
  const { limit, resets_at: resetsAt } = projectQuotaState || {};

  // Keyed on the state object so back-to-back rejections each count.
  useEffect(() => {
    if (projectQuotaState) {
      Mixpanel.track('Project Quota Exceeded Served', { limit, resets_at: resetsAt });
    }
  }, [projectQuotaState]);

  const resetLabel = formatQuotaResetsAt(resetsAt, { withDate: true });

  return (
    <BasicModal
      showModal={!!projectQuotaState}
      setShowModal={(open) => {
        if (!open) hideProjectQuotaError();
      }}
      ariaLabel='Weekly limit reached'
      dialogPadding='p-0'
      maxWidth='sm:max-w-[480px]'
      icon={null}
      iconBackground='bg-none'>
      <div className='flex flex-col'>
        {/* pr-10 keeps the heading clear of the close button */}
        <div className='px-6 pr-10 pt-6 pb-6 sm:px-8 sm:pr-10 sm:pt-8'>
          <h2 className='text-2xl font-semibold leading-tight'>Weekly limit reached</h2>
          <p className='mt-2 text-sm text-gray-500'>
            {limit
              ? `Free accounts in your region are limited to ${limit} new ${resourceNoun(limit)} each week.`
              : 'Free accounts in your region are limited to a set number of new resources each week.'}
            {resetLabel ? ` Your limit resets on ${resetLabel}.` : ''} Please upgrade for unlimited
            weekly resources.
          </p>
        </div>
        <div className='flex justify-end gap-x-3 border-t border-gray-100 bg-white px-6 py-4 sm:px-8'>
          <button
            type='button'
            onClick={hideProjectQuotaError}
            className='rounded-md px-4 py-2 font-semibold text-gray-600 hover:bg-gray-100'>
            Close
          </button>
          <button
            type='button'
            onClick={() => {
              openQuotaUpgrade('quota_modal', { limit, remaining: 0 });
              hideProjectQuotaError();
            }}
            className='rounded-md bg-emerald-600 px-4 py-2 font-semibold text-white hover:bg-emerald-500'>
            Upgrade for Unlimited
          </button>
        </div>
      </div>
    </BasicModal>
  );
}
